import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MarketFeatureKey } from './market.reducer';

const getMarketFeatureKey = createFeatureSelector<any>(MarketFeatureKey);

export const getError = createSelector(
    getMarketFeatureKey,
(state: any) => {
  return state.error
}
);

export const getAllMissions = createSelector(
  getMarketFeatureKey,
(state: any) => {
return state.allMissions
}
);

export const getMyMissions = createSelector(
  getMarketFeatureKey,
(state: any) => {
return state.myMissions
}
);

export const getUser = createSelector(
    getMarketFeatureKey,
(state: any) => {
  return state.user
}
);



export const login = createSelector(
    getMarketFeatureKey,
(state: any) => {
  return state.login
}
);

export const getNfts = createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.nfts
}
);

export const getNav = createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.isNav
}
);

export const getPurchase = createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.purchase
}
);


export const getPop = createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.pop
}
);

export const getTokens = createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.tokens
}
);


export const getClaim = createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.claim
}
);

export const getShowNfts = createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.showNfts
}
);

export const getLevels = createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.levels
}
);

export const getFilterMissions = createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.filteredMissions
}
);

export const getFilter = createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.filter
}
);

export const getInventory = createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.inventory
}
);

export const getMyInventory = createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.myInventory
}
);

export const getScores = createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.scores
}
);

export const getAllSkills = createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.allSkills
}
);

export const getPastSeason = createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.pastSeason
}
);

export const getSeason = createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.season
}
);

export const getOnMissions = createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.onMissions
}
);

export const getClaimable = createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.claimable
}
);

export const getSelectDetails= createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.selectDetails
}
);

export const getPass= createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.pass
}
);

export const getPassRewards= createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.passrewards
}
);

export const getUserSeasonRewards= createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.userSeasonRewards
}
);

export const getSelectPack= createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.selectPack
}
);

export const getEth= createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.eth
}
);

export const getPackSigs= createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.packSigs
}
);

export const getPacks= createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.packs
}
);

export const getCards= createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.cards
}
);

export const getLoading= createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.loading
}
);

export const getOpened= createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.opened
}
);

export const getApproval= createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.approval
}
);

export const getShowProfileEdit= createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.showProfileEdit
}
);

export const getUserScore= createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.userScore
}
);

export const getUpgrade= createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.upgrade
}
);

export const getUserSell= createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.userSell
}
);

export const getAllSell = createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.allSell
}
);

export const getModal = createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.modal
}
);

export const getShareprofile = createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.shareprofile
}
);

export const getMobileMenu = createSelector(
  getMarketFeatureKey,
(state: any) => {
  return state.mobileMenu
}
);


export const MarketQuery = {
    getMarketFeatureKey,
    getError,
    getUser,
    login,
    getAllMissions,
    getMyMissions,
    getNfts,
    getNav,
    getPurchase,
    getPop,
    getTokens,
    getClaim,
    getShowNfts,
    getLevels,
    getFilterMissions,
    getFilter,
    getInventory,
    getMyInventory,
    getScores,
    getAllSkills,
    getSeason,
    getPastSeason,
    getOnMissions,
    getClaimable,
    getSelectDetails,
    getPass,
    getPassRewards,
    getUserSeasonRewards,
    getSelectPack,
    getEth,
    getPackSigs,
    getPacks,
    getCards,
    getOpened,
    getLoading,
    getApproval,
    getShowProfileEdit,
    getUserScore,
    getUpgrade,
    getUserSell,
    getAllSell,
    getModal,
    getShareprofile,
    getMobileMenu
};